import React, { Fragment } from "react"
import { Helmet } from "react-helmet"

//components
import ThemeMenuThree from "../../../components/header/ThemeMenuThree"
import PageTitle from "../../../components/page-title/PageTitle"
import FeatureFour from "../../../components/feature/FeatureFour"
import NewsletterTwo from "../../../components/call-to-action/NewsletterTwo"
import FooterThree from "../../../components/footer/FooterThree"


const Services = () => {
    return (
        <Fragment>
            <div className="main-page-wrapper">
                {/* Helmet start */}
                <Helmet>
                    <title>Servicios Tecnológicos en Ecuador</title>
                    <meta name="description" content="Servicios tecnológicos de CuySoft en Ecuador: desarrollo web, diseño UI/UX, ciberseguridad, marketing digital y consultoría IT. Soluciones para impulsar tu negocio." />
                    <meta name="keywords" content="servicios tecnológicos Ecuador, desarrollo web, diseño UI/UX, ciberseguridad, marketing digital, consultoría IT, CuySoft" />
                    <link rel="canonical" href="https://www.cuysoft.com/services" />
                    <meta property="og:title" content="Servicios Tecnológicos – CuySoft Ecuador" />
                    <meta property="og:description" content="Desarrollo web, diseño UI/UX, ciberseguridad, marketing digital y más. Servicios tecnológicos para empresas en Ecuador." />
                    <meta property="og:url" content="https://www.cuysoft.com/services" />
                </Helmet>
                {/* Helmet end */}

                {/* ThemeMenuThree */}
                <ThemeMenuThree />
                {/* ThemeMenuThree */}

                {/* PageTitle */}
                <PageTitle title="Servicios" />
                {/* PageTitle */}

                {/*our-services start*/}
                <section className="our-services service-bg-two pt-145 pb-100 pt-lg-60 pb-lg-20">
                    <div className="container">
                        <div className="row gx-4 gx-xxl-5 align-items-center justify-content-center">
                            <div className="col-xl-5 col-lg-6 col-md-8">
                                <div className="section-title text-center mb-55">
                                    <h3 className="sect-title mb-25" data-aos="fade-up">Nuestros Servicios</h3>
                                    <p data-aos="fade-up" data-aos-delay={100}>Ofrecemos soluciones transparentes
                                        y entregas eficientes a través de fuentes internas u "orgánicas".</p>
                                </div>
                            </div>
                        </div>
                        <FeatureFour />
                    </div>
                </section>
                {/*our-services end*/}


                {/*cuysoft-newsletter start*/}
                <NewsletterTwo />
                {/*cuysoft-newsletter end*/}

                {/* FooterThree start */}
                <FooterThree />
                {/* FooterThree end */}

            </div>

        </Fragment>
    )
}

export default Services